import React from 'react';
import { FadeIn } from './FadeIn';
import { FileText, Stethoscope, Syringe, MessageCircle, Activity, Building2 } from 'lucide-react';
export function TomosSection() {
  const tomos = [{
    icon: <FileText className="w-8 h-8" data-id="element-134" />,
    title: 'Tomo 1 — Historia clínica completa',
    desc: '8 modelos: caninos, felinos, cachorros, geriátricos, evolución continua, epicrisis, consentimiento informado y ficha de alerta.'
  }, {
    icon: <Stethoscope className="w-8 h-8" data-id="element-135" />,
    title: 'Tomo 2 — Presupuestos quirúrgicos y odontológicos',
    desc: '11 modelos: castraciones, cesárea, tejidos blandos, profilaxis dental, extracciones e internación.'
  }, {
    icon: <Syringe className="w-8 h-8" data-id="element-136" />,
    title: 'Tomo 3 — Planes sanitarios anuales',
    desc: '8 modelos para todas las etapas de vida de perros y gatos, con calendarios de vacunación y desparasitación.'
  }, {
    icon: <MessageCircle className="w-8 h-8" data-id="element-137" />,
    title: 'Tomo 4 — Comunicaciones para dueños',
    desc: '18 mensajes listos para WhatsApp: post-cirugía, recordatorios, diagnósticos graves, eutanasia y más.'
  }, {
    icon: <Activity className="w-8 h-8" data-id="element-138" />,
    title: 'Tomo 5 — Protocolos de internación y monitoreo',
    desc: 'Fichas de ingreso, monitoreo horario, registro de medicación, fluidos y protocolos de urgencia.'
  }, {
    icon: <Building2 className="w-8 h-8" data-id="element-139" />,
    title: 'Tomo 6 — Gestión del consultorio',
    desc: 'Contratos, registros económicos, control de stock, protocolos operativos y documentación legal.'
  }];
  return <section className="px-4 max-w-6xl mx-auto mb-10 md:mb-16" data-id="element-140">
      <FadeIn data-id="element-141">
        <div className="text-center mb-12 md:mb-16" data-id="element-142">
          <h2 className="text-3xl md:text-5xl font-black text-brand-white mb-4" data-id="element-143">
            Todo lo que incluye Consultorio en orden
          </h2>
          <p className="text-xl md:text-3xl text-brand-gold font-bold" data-id="element-144">
            6 tomos + 6 bonos
          </p>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-145">
        {tomos.map((tomo, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-146">
            <div className="bg-brand-white/5 border border-brand-white/10 rounded-2xl p-6 md:p-8 h-full hover:bg-brand-white/10 transition-colors" data-id="element-147">
              <div className="text-brand-gold mb-5" data-id="element-148">{tomo.icon}</div>
              <h3 className="text-lg md:text-xl font-bold text-brand-white mb-3 md:mb-4" data-id="element-149">
                {tomo.title}
              </h3>
              <p className="text-brand-cream/80 text-sm md:text-base leading-relaxed font-medium" data-id="element-150">
                {tomo.desc}
              </p>
            </div>
          </FadeIn>)}
      </div>
    </section>;
}